import appService from '../../server/app.service'
import { getField, updateField } from 'vuex-map-fields'
import languages from './languages'

const state = {
    details: {},
    scripts: [],
    parameters: [],
    texts: {
        accessibilityLabel: {},
        accessibilityTitleSite: {},
        accessibilityTextSite: {},
        accessibilityTitleBooking: {},
        accessibilityTextBooking: {}
    },
    scriptTypes: [],
    languages: [],
    languageSelected: 'ita',
    id: 0
}

const getters = {
    details: state => state.details,
    scripts: state => state.scripts,
    parameters: state => state.parameters,
    texts: state => state.texts,
    scriptTypes: state => state.scriptTypes,
    languages: state => state.languages,
    languageSelected: state => state.languageSelected,
    getField
}

const actions = {
    async loadSettings(context, credentials) {
        try {
            const data = await appService.connectToServer(credentials)
            context.commit('loadSettings', { result: data })
        } catch (error) {
            this.dispatch('addMessage', error.toString())
        }
    },

    async saveSettings({ state, commit }, credentials) {
        try {
            const data = await appService.connectToServer({
                ...credentials,
                scripts: state.scripts,
                parameters: state.parameters
            })
            if (data.success) {
                commit('saveSettings', {
                    Settings: data.Settings,
                    Scripts: data.Scripts
                });
            }
            this.dispatch('addMessage', data.success ? data : data)
        } catch (error) {
            this.dispatch('addMessage', error.toString())
        }
    },

    addScript({ commit }) {
        commit('addScript')
    },

    deleteScript({ commit }, id) {
        commit('deleteScript', id)
    },

    addParameter({ commit }) {
        commit('addParameter')
    },

    deleteParameter({ commit }, index) {
        commit('deleteParameter', index)
    },

    addCondition({ commit }, { parentIndex, path }) {
        commit('addCondition', { parentIndex, path })
    },

    deleteCondition({ commit }, { parentIndex, path }) {
        commit('deleteCondition', { parentIndex, path })
    },

    languageSelect(context, slug) {
        context.commit('languageSelect', slug)
    },
}

const mutations = {

    saveSettings(state, { Settings, Scripts  }) {
        state.details.requestLogCreate = Settings.requestLogCreate;
        state.details.requestLogUpade = Settings.requestLogUpade;
        state.scripts = Scripts
    },

    loadSettings(state, data) {

        const result = data.result.data
        state.details = {
            requestLogCreate: result.Settings.requestLogCreate,
            requestLogUpade: result.Settings.requestLogUpade
        }
        state.scripts = result.Scripts
        state.scriptTypes = result.ScriptType
        state.parameters = result.Settings.parameters || []

        const textsValue = typeof result.Settings.texts === 'object' ? result.Settings.texts : {};
        state.texts = {
            accessibilityLabel: {},
            accessibilityTitleSite: {},
            accessibilityTextSite: {},
            accessibilityTitleBooking: {},
            accessibilityTextBooking: {},
            ...textsValue
        }
        state.languages = result.Languages
    },

    addScript(state) {
        state.scripts.push({ active: '1', platform: '1', type_id: '1', script: '', id: '', deleted: false })
    },

    deleteScript(state, id) {
        if (state.scripts[id]) {
            state.scripts[id].deleted = true
        }
    },

    addParameter(state) {
        state.parameters.push({
            name: '',
            conditions: []
        });
    },

    deleteParameter(state, index) {
        state.parameters.splice(index, 1)
    },

    // RICORSIVO: aggiunge una condizione in un path
    addCondition(state, { parentIndex, path }) {
        if (typeof parentIndex === 'undefined' || !state.parameters[parentIndex]) {
            console.warn('Invalid parentIndex in addCondition:', parentIndex);
            return;
        }

        if (path.length >= 2) {
            console.warn('Maximum depth of 3 levels reached, cannot add more conditions.');
            return;
        }

        const target = resolveNestedCondition(state.parameters[parentIndex].conditions, path);
        if (!Array.isArray(target)) {
            console.warn('Target is not a valid array to push into');
            return;
        }

        // Aggiorna l'operatore dell'ultimo elemento esistente (se c'è)
        if (target.length > 0) {
            target[target.length - 1].operator = 'AND'; // o 'OR' se vuoi consentirlo in UI
        }

        // Aggiungi nuova condizione con operatore vuoto (ultimo elemento)
        target.push({ name: '', type: 'query', operator: '', conditions: [] });
    },


    deleteCondition(state, { parentIndex, path, index }) {
        const target = resolveNestedCondition(state.parameters[parentIndex].conditions, path);
        if (target && Array.isArray(target)) {
            target.splice(index, 1);

            // Se rimangono elementi, imposta l'ultimo operatore a ''
            if (target.length > 0) {
                target[target.length - 1].operator = '';
            }
        }
    },

    updateScriptsOrder(state, newOrder) {
        state.scripts = [...newOrder];
    },

    languageSelect (state, slug) {
        state.languageSelected = slug.slug
    },

    updateField
}

// 🔁 Funzione ausiliaria ricorsiva per navigare nel path delle condizioni
function resolveNestedCondition(rootConditions, path) {
    let current = rootConditions;
    for (const index of path) {
        if (!current[index]) {
            console.warn('Invalid path index:', index);
            return [];
        }
        current = current[index].conditions;
    }
    return current;
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
